/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Marker_CommentInputs */



/**
* | output |
* | --- |
* | "Insert Marker + Comment" |
*
* @param {Shortcut_Keys_Name_Insert_Marker_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_marker_comment = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Marker_CommentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Marker_CommentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer un marqueur + commentaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Marker + Kommentar einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci marcatore + commento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить маркер + комментарий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar marcador + comentario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入标记 + 注释")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカー + コメントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर + टिप्पणी डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir marcador + comentário")
	return /** @type {LocalizedString} */ ("Insert Marker + Comment")
});